import { render, staticRenderFns } from "./RefrigeratedIconTag.vue?vue&type=template&id=6ed0d597&scoped=true&"
import script from "./RefrigeratedIconTag.vue?vue&type=script&lang=js&"
export * from "./RefrigeratedIconTag.vue?vue&type=script&lang=js&"
import style0 from "./RefrigeratedIconTag.vue?vue&type=style&index=0&id=6ed0d597&lang=sass&scoped=true&"
import style1 from "./RefrigeratedIconTag.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed0d597",
  null
  
)

export default component.exports